// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "9edcda5c52dfe8c998bd" + ".chunk.js";
};